import React from "react";

import Input from "components/ui/Input";
import Button from "components/ui/Button";

const STATUS_OPTIONS = [
  { value: "ALL", label: "Todos los estados" },
  { value: "PENDING", label: "Pendiente" },
  { value: "ACTIVE", label: "Activo" },
  { value: "SUSPENDED", label: "Suspendido" },
  { value: "REJECTED", label: "Rechazado" },
];

const FilterBar = ({ filters, onFilterChange, onExport, selectedCount, onBulkApprove, onBulkReject }) => {
  return (
    <div className="bg-white rounded-xl border p-4 mb-4 shadow-sm" style={{ borderColor: "var(--color-border)" }}>
      <div className="flex flex-col md:flex-row gap-3 items-start md:items-end">
        <div className="flex-1 min-w-0">
          <Input
            type="search"
            placeholder="Buscar por NIT, razón social o correo..."
            value={filters?.search}
            onChange={(e) => onFilterChange("search", e?.target?.value)}
            label="Búsqueda"
          />
        </div>

        <div className="w-full md:w-48">
          <label className="block text-xs font-caption mb-1" style={{ color: "var(--color-muted-foreground)" }}>
            Estado
          </label>
          <select
            value={filters?.status}
            onChange={(e) => onFilterChange("status", e?.target?.value)}
            className="w-full h-10 px-3 rounded-lg border text-sm font-caption focus:outline-none focus:ring-2"
            style={{
              borderColor: "var(--color-border)",
              backgroundColor: "var(--color-card)",
              color: "var(--color-foreground)",
              focusRingColor: "var(--color-ring)",
            }}
          >
            {STATUS_OPTIONS?.map((opt) => (
              <option key={opt?.value} value={opt?.value}>
                {opt?.label}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full md:w-40">
          <label className="block text-xs font-caption mb-1" style={{ color: "var(--color-muted-foreground)" }}>
            Desde
          </label>
          <input
            type="date"
            value={filters?.dateFrom}
            onChange={(e) => onFilterChange("dateFrom", e?.target?.value)}
            className="w-full h-10 px-3 rounded-lg border text-sm font-caption focus:outline-none"
            style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-card)", color: "var(--color-foreground)" }}
          />
        </div>

        <div className="w-full md:w-40">
          <label className="block text-xs font-caption mb-1" style={{ color: "var(--color-muted-foreground)" }}>
            Hasta
          </label>
          <input
            type="date"
            value={filters?.dateTo}
            onChange={(e) => onFilterChange("dateTo", e?.target?.value)}
            className="w-full h-10 px-3 rounded-lg border text-sm font-caption focus:outline-none"
            style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-card)", color: "var(--color-foreground)" }}
          />
        </div>

        <Button variant="outline" iconName="Download" iconPosition="left" onClick={onExport} className="whitespace-nowrap">
          Exportar
        </Button>
      </div>
      {selectedCount > 0 && (
        <div className="mt-3 pt-3 border-t flex flex-wrap items-center gap-2" style={{ borderColor: "var(--color-border)" }}>
          <span className="text-sm font-caption" style={{ color: "var(--color-muted-foreground)" }}>
            {selectedCount} seleccionado(s)
          </span>
          <Button variant="success" size="sm" iconName="UserCheck" iconPosition="left" onClick={onBulkApprove}>
            Aprobar seleccionados
          </Button>
          <Button variant="destructive" size="sm" iconName="UserX" iconPosition="left" onClick={onBulkReject}>
            Rechazar seleccionados
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;